import React from 'react'

import { func, string } from 'prop-types'
import Typography from 'components/atoms/Typography'
import { SVGIcon } from 'components/qstrap'

const InfoBox = ({ message, handleDismiss }) => (
  <div className="info-box">
    <Typography variant="subbody" className="info-box__message">
      {message}
    </Typography>
    {handleDismiss && (
      <div onClick={handleDismiss} className="info-box__close">
        <SVGIcon name="close" color="#FFF" />
      </div>
    )}
    <style jsx>
      {`
        .info-box {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          padding: 16px;
          margin: 0 16px 16px;
          border-radius: 8px;
          background-color: #00c2c9;
          :global(&__message) {
            color: #fff !important;
            font-weight: bold !important;
            margin: 0 !important;
          }
          &__close {
            cursor: pointer;
            margin-left: 16px;
          }
          @media screen and (min-width: 768px) {
            padding: 24px;
            margin: 0 0 24px;
            align-items: center;
            :global(&__message) {
              font-size: 16px !important;
            }
          }
        }
      `}
    </style>
  </div>
)

InfoBox.propTypes = {
  message: string,
  handleDismiss: func,
}

export default InfoBox
